import "../css/SideNavbar.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SideNavBarSales(props) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState("");
    const [showSubMenu, setShowSubMenu] = useState("");

    useEffect(() => {
        setShowMenu(props.activeMenu)
    }, [props.activeMenu]);

    useEffect(() => {
        setShowSubMenu(props.activeSubMenu)
    }, [props.activeSubMenu]);
    
    return (
        <>
            <a onClick={() => setShowMenu(showMenu=="Sales"?"":"Sales")} title="Sales" className={props.activeMenu == "Sales" ? "sidenav-expanded-active pointer px-0 sidenavbar-text" : "pointer px-0 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("sales:sales:view")?false:true}>
                <i className="fa fa-clipboard sidenavbar-icon px-3"></i>
                <span className="mx-3 sidenavbar-text">Sales
                    <i className={showMenu=="Sales"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                </span>
            </a>
            <ul className={showMenu == "Sales" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/sales/customer")} title="Customer" 
                className={props.activeSubMenu == "SalesCustomer" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("sales:customer:view")?false:true}>
                    <span className="mx-3">Customer</span>
                </a>
            </ul>
        </>
    );
}

export default SideNavBarSales;
